import { useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'

import ModerationCard from './components/ModerationCard/ModerationCard'
import s from './components/ModerationCard/Moderation.module.scss'
import { useFetch } from 'hooks/useFetch'

import { useAppErrorContext } from 'contexts/AppErrorContext'
import { useAppSuccessMessageContext } from 'contexts/SuccessMessageContext'

import { moderateApi } from 'api/moderate-api'

import check from 'assets/svg/icons-check.svg'

import Header from 'components/UI/Header'
import { NoContent } from 'components/UI/NoContent/NoContent'
import PageTitle from 'components/UI/PageTitle'

const ModerationPage = () => {
  const { setSuccessMessage } = useAppSuccessMessageContext()
  const [, setSearchParams] = useSearchParams()
  const { setAppError } = useAppErrorContext()

  const [handlersloading, setLoading] = useState(false)
  const {
    data,
    loading,
    fetchData: getData,
  } = useFetch({
    getData: () => moderateApi.getConsents(),
  })

  const declineHandler = async () => {
    setLoading(true)
    if (data?.related_place?.id) {
      try {
        await moderateApi.approve(+data.related_place.id, false)
        localStorage.removeItem('adPlaceId')
        getData()
        setSuccessMessage('The campaign has been declined.')
      } catch (e) {
        setAppError(e)
      }
    }
    setLoading(false)
  }

  const approveHandler = async () => {
    setLoading(true)
    if (data?.related_place?.id) {
      localStorage.setItem('adPlaceId', data?.related_place?.id.toString())
      try {
        const res = await moderateApi.check(+data?.related_place?.id)
        if (res.status === 200) {
          const approveRes = await moderateApi.approve(+data?.related_place?.id, true)
          localStorage.removeItem('adPlaceId')
          getData()
          setSearchParams({})
          if (approveRes.status === 200) setSuccessMessage('The campaign has been approved.')
        }
      } catch (e: any) {
        setAppError(`Such campaign doesn't exist or already started. Please, refresh page.`)
      }
    }
    setLoading(false)
  }

  return (
    <div>
      <Outlet />
      <Header className={s.header}>
        <PageTitle title={data?.total_elements ? 'Moderation' : null} count={0} loading={loading || handlersloading} />
      </Header>
      <main>
        {data?.total_elements && data ? (
          <>
            <ModerationCard item={data} declineHandler={declineHandler} approveHandler={approveHandler} />
          </>
        ) : (
          <NoContent
            icon={check}
            title="All Content Moderated"
            subtitle="There’s no content awaiting moderation yet."
          />
        )}
      </main>
    </div>
  )
}

export default ModerationPage
